export const clone_page_atom_service_to_theme_atom_service = {
  error_unknown: 'Quelque chose ne va pas',
  clone_error: 'Erreur de clonage',
  clone_success: 'Clonage réussi',
  cloning: 'Clonage en cours',
  init_clone: 'Initialisation du clonage',
  init_clone_error: "Erreur lors de l'initialisation du clonage",
} as const;
